import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { Button, Drawer, IconButton, SxProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FeedbackDrawerModel } from '~/model/model.feedback.drawer';
import { AsyncView } from '../view.async';
import { Col, Row, Text } from '../view.box';
import { FeedbackDrawerAuthor } from './feedback.drawer.author';
import { FeedbackDrawerComment } from './feedback.drawer.comment';
import { FeedbackDrawerContext } from './feedback.drawer.ctx';
import { FeedbackDrawerDetails } from './feedback.drawer.details';
import { FeedbackDrawerPost } from './feedback.drawer.post';
import { FeedbackDrawerSimilar } from './feedback.drawer.similar';
import { FeedbackDrawerUser } from './feedback.drawer.user';
import { FeedbackReplyDialog } from './feedback.reply.dialog';

const sxDrawer: SxProps = {
	width: 400,
	flexShrink: 0,
	'& .MuiDrawer-paper': {
		width: 400,
		top: 64,
		px: 2,
		height: 'calc(100% - 64px)',
		boxSizing: 'border-box',
		zIndex: 1000,
	},
};

export const FeedbackDrawerItem = styled.div({
	flexDirection: 'row',
	display: 'flex',
	justifyContent: 'space-between',
	borderBottom: 'solid #dadada 1px',
	paddingBottom: 3,
	gap: 16,
});

export const FeedbackDrawerTitle = styled.div({
	fontWeight: '600',
	fontFamily: 'sans-serif',
	fontSize: 14,
	minWidth: 120,
});

export const FeedbackDrawerValue = styled.div({
	fontFamily: 'sans-serif',
	overflowWrap: 'anywhere',
});

export const FeedbackDrawer = observer<{ model: FeedbackDrawerModel }>(({ model }) => {
	const {
		async,
		selectedItem,
		resolveSelectedItem,
		reopenSelectedItem,
		setSelectedItem,
		declineSelectedItem,
		showReplyDialog,
	} = model;

	return (
		<FeedbackDrawerContext.Provider value={model}>
			<Drawer
				sx={sxDrawer}
				PaperProps={{ elevation: 4 }}
				variant="persistent"
				anchor="right"
				open={!!selectedItem}
			>
				<FeedbackReplyDialog />
				<AsyncView async={async}>
					<Col gap={1}>
						<Row justifyContent="flex-start" py={1} alignItems="center">
							<IconButton onClick={() => setSelectedItem(undefined)}>
								<Close />
							</IconButton>
							<Text fontWeight={500}>{selectedItem?.type}</Text>
						</Row>
						<FeedbackDrawerAuthor />
						<FeedbackDrawerDetails />

						{selectedItem?.type === 'POST_COMMENT_COMPLAINT' ? (
							<FeedbackDrawerComment />
						) : selectedItem?.type === 'POST_COMPLAINT' ? (
							<FeedbackDrawerPost />
						) : selectedItem?.type === 'USER_COMPLAINT' ? (
							<FeedbackDrawerUser />
						) : selectedItem?.type === 'FRAG_SUGGESTION' ? (
							<FeedbackDrawerSimilar />
						) : null}

						<Row justifyContent="space-between" mt={2} gap={2}>
							<Button fullWidth variant="contained" onClick={showReplyDialog}>
								Reply
							</Button>
							{selectedItem?.status === 'NEW' ? (
								<Button fullWidth variant="contained" onClick={resolveSelectedItem}>
									Resolve
								</Button>
							) : (
								<Button fullWidth variant="contained" onClick={reopenSelectedItem}>
									Reopen
								</Button>
							)}
							<Button fullWidth variant="contained" onClick={declineSelectedItem}>
								Decline
							</Button>
						</Row>
					</Col>
				</AsyncView>
			</Drawer>
		</FeedbackDrawerContext.Provider>
	);
});
